const config = require('../data.json');

export const navItems = [
  {
    children: '全部商品',
    url: '/products',
  },
  {children: config.mapping.about, url: '/about'},
  ...(config.isLiteVersion
    ? []
    : [{children: config.mapping.articles, url: '/articles'}]),
  // 企業專區 /business 不供白牌（src/Templates/Business/ 未納入本 repo，
  // 且 config.mapping.business 未定義會渲染成 undefined）。
  {children: config.mapping.faq, url: '/faq'},
];
